export const LOAD_PERSONAL_OFFERS = "LOAD_PERSONAL_OFFERS";
export const GET_OFFER_BY_ID = "GET_OFFER_BY_ID";
